export default __webpack_public_path__ + "29b2ed76ca0b710c6e9ca9e21e71f3e3.svg";